import React from "react";
import BaibolItem from "./BaibolItem/BaibolItem";
import SberItem from "./SberItem/SberItem";
import EleksnetItem from "./EleksnetItem/EleksnetItem";
import CrownItem from "./CrownItem/CrownItem";

import './WherePay.scss';

const WherePay: React.FC = () => (
    <section className="where__pay">
        <div className="section__wrapper">
            <h2>Где можно оплатить заём</h2>
            <div className="where__pay__items">
                <BaibolItem />
                <SberItem />
                <EleksnetItem />
                <CrownItem />
            </div>
            <div className="attention-text">
                <p>посещение сайта, приобретение и доставка конкретного товара/услуги могут быть незаконными на
                    территории страны, в которой находится держатель карты.</p>
                <p>держатель карты несет ответственность за невыполнение законов своей страны при посещении
                    данного сайта и попытке приобрести товары/услуги, если таковые запрещены законодательством
                    на территории страны, в которой он находится.</p>
            </div>
        </div>
    </section>
);

export default WherePay;